import { GET_NATURE_MAGAZINE_START } from "../../types";

export const nature_magazine = (payload) => ({
    type: GET_NATURE_MAGAZINE_START,
    payload,
});
